// Internal click tracking push to pixel
      document.addEventListener('DOMContentLoaded', function () {
        document.querySelectorAll('[data-cta]').forEach(function (el) {
          el.addEventListener('click', function () {
            var ctaName = el.getAttribute('data-cta');
            if (window.Shopify && window.Shopify.analytics) {
              window.Shopify.analytics.publish('cta_click', {
                cta_name: ctaName,
                page_location: window.location.href
              });
            }
            console.log('CTA clicked:', ctaName);
          });
        });
      });